import discountClubHistoriesHtml from './discountClubHistories.html';

class DiscountClubHistoriesController {
    constructor($scope) {
        'ngInject';

        this.$scope = $scope;

        this.histories = [];
        this.itemsPerPage = 20;
    }
}

let DiscountClubHistoriesComponent = {
    bindings: {
        histories: '<'
    },
    template: discountClubHistoriesHtml,
    controller: DiscountClubHistoriesController
};

export default DiscountClubHistoriesComponent;
